module.exports = __webpack_public_path__ + "static/media/ai.97822d0c.jpeg";